import { render, staticRenderFns } from "./RadarChart.vue?vue&type=template&id=164578b5&scoped=true&"
import script from "./RadarChart.vue?vue&type=script&lang=js&"
export * from "./RadarChart.vue?vue&type=script&lang=js&"
import style0 from "./RadarChart.vue?vue&type=style&index=0&id=164578b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164578b5",
  null
  
)

export default component.exports